import { Component, Vue } from 'vue-property-decorator'
import { inject } from 'inversify-props'
import { UIService } from '@core/services/UIService'
import { SharedVariable } from '@core/model/SharedVariable'

type Directory = {
  title: string;
  routeName?: string; // for named route in router
  path?: string; // for legacy page
  show: boolean;
}
@Component
export class HomeMixin extends Vue {
  protected isLoading = false

  protected error: string

  uiService: UIService

  @inject()
  private sharedVariable: SharedVariable

  get currentUser () {
    return this.$store.getters.currentUser
  }

  get isSuperUser () {
    return this.currentUser.isSuperUser
  }

  get isBscReviewer () {
    return this.$store.getters.isBscReviewer
  }

  get isProductAdmin () {
    return this.$store.getters.isProductAdmin
  }

  get isAdviser () {
    return this.$store.getters.isAdviser
  }

  get isSupervisor () {
    return this.$store.getters.isSupervisor
  }

  get directories (): Directory[] {
    return [
      {
        title: 'Bsc Home',
        routeName: 'bsc-home',
        show: this.isBscReviewer
      },
      {
        title: 'Adviser Home',
        routeName: 'home-adviser',
        show: this.isAdviser || this.isSupervisor || this.isSuperUser
      },
      {
        title: 'Supervisor Home',
        routeName: 'home-supervisor',
        show: this.isSupervisor || this.isSuperUser
      },
      {
        title: 'Submission Home',
        routeName: 'home-submission',
        show: this.isSuperUser
      },
      {
        title: 'User Administration',
        routeName: 'user-list',
        show: this.isSuperUser
      },
      {
        title: 'Group Administration',
        routeName: 'group-list',
        show: this.isSuperUser
      },
      {
        title: 'Product Management',
        path: 'admin-products',
        show: this.isSuperUser || this.isProductAdmin
      }
    ]
  }

  get allowedDirectories (): Directory[] {
    return this.directories.filter(direct => direct.show)
  }

  goTo (direct: Directory) {
    if (direct.routeName) {
      this.$router.push({ name: direct.routeName })
    } else window.location.href = `/live/${direct.path}`
  }

  async created () {
    // take injected UIService and set it to local
    this.uiService = this.sharedVariable.uiService
  }
}
